<template>
  <v-app>
    <v-overlay :absolute="false" :value="wait" :opacity="0.75" z-index="999">
      <v-progress-linear :size="150" :width="10" color="#eeeeff" indeterminate></v-progress-linear>
    </v-overlay>

    <!-- <AppNavDrawer /> -->
    <SplashTopBar />

    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
// import Chat from '@/components/chat/Chat.vue';
// import io from 'socket.io-client';

import SplashTopBar from '@/layouts/app/SplashTopBar.vue';
import AppNavDrawer from '@/layouts/app/AppNavDrawer.vue';

// UI Composable
import { useUi } from '@/module/ui';

export default defineComponent({
  name: 'SplashLayout',
  components: {
    SplashTopBar,
    AppNavDrawer
    // Chat
  },

  setup() {
    const { wait, waitToggle } = useUi();

    return { wait, waitToggle };
  }
});
</script>
